<template>
     <div id="J_chartLineBox" style="width:48%;height:275px" class="float2"></div>
</template>
<script>
export default {
    data () {
      return {
        id: 'F05_01_03',
        code: null,
        pagesize: 10,
        begindate: null,
        enddate: null,
        other: null,
        zg: [],
        chartLine: '',
        dataListLoading: false,
        name:'',
        name1:'',
        optionData1: [],
        optionData2: [],
        optionData3: [],
        minus:''
        }
    },
    created () {
        this.code = this.$route.query.code
        this.getDataList3()
    },
    mounted () {
        this.initChartLines1()
    },
    watch:{
        optionData1(n,o,){
        this.initChartLines1()
        },
        optionData2(n,o){
        this.initChartLines1()
        }, 
        optionData3(n,o){
        this.initChartLines1()
        },
        zg(n,o){
        this.initChartLines1()
        },
        name(n,o){
            this.initChartLines1()
        },
        name1(n,o){
            this.initChartLines1()
        }
    },
    activated () {
        if (this.chartLine) {
        this.chartLine.resize()
        }
    },
     methods: {
      initChartLines1 () {
        var option = {
            tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                var str = ''
                if (params[0] != null) {
                str += '日期：' + params[0].axisValue + '<br />'
                if (params[0].seriesIndex === 0) {
                    str += '' + params['0'].seriesName + '：' + params['0'].value + this.minus + '<br />'
                } else {
                    str += '' + params['0'].seriesName + '：' + params['0'].value + this.minus + '<br />'
                }
                }
                if (params[1] != null) {
                str += '' + params['1'].seriesName + '：' + params['1'].value + this.minus + '<br />'
                }
                return str
                }
            },
            legend: {
                x : 'center',
                y : 'top',
                data:this.zg
            },
            grid: {
            x: 70,
            y: 70,
            x2: 15,
            y2: 20
            },
            color: ['#5ac6ca'],
            xAxis: {
            type: 'category',
            boundaryGap: false,
            data:this.optionData1,
            axisTick: {
                show: true,
                lineStyle: {
                color: '#DFE1E5'
                }
            },
            axisLine: {show: false}},
            yAxis: {
            name:'万美元',
            type: 'value',
            axisTick: {
                show: true,
                lineStyle: {
                color: '#DFE1E5'
                }
            },
            axisLine: {show: false}
            },
            series: [
            {
                name:this.name,
                type: 'line',
                color: ['#4ABFBC'],
                data:this.optionData2,
                areaStyle: {}
            },
            {
                name:this.name1,
                type: 'line',
                color: ['#fd7e33'],
                data:this.optionData3,
                areaStyle: {}
            }
            ]
        }
        this.chartLine = echarts.init(document.getElementById('J_chartLineBox'))
        this.chartLine.setOption(option)
        window.addEventListener('resize', () => {
        this.chartLine.resize()
        })
      },
      getDataList3 () {
        this.$axios.get('http://140.143.151.238:8080/infoapp1/app/dinarp/rawrp',{
        params: {
            'id': this.id,
            'code': this.code,
            'pagesize': this.pagesize,
            'begindate': this.begindate,
            'enddate': this.enddate,
            'other': this.other
            }
        })
        .then(res=> {
            let rest = res.data.data
            for ( const item of rest) { 
            this.zg.push(item.label_in,item.label_ex) 
            }
            // console.log(this.zg)
            this.optionData1 = res.data.data[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
            this.optionData2 = res.data.data[0].value_in.split(',').map(item => item.replace(/\'/g, ''))
            this.optionData3 = res.data.data[0].value_ex.split(',').map(item => item.replace(/\'/g, ''))
            this.minus = res.data.data[0].unit_final_in.substr(0,3)
            this.name = res.data.data[0].label_in
            this.name1 = res.data.data[0].label_ex
            console.log(  this.name1,  this.name)
        })
        }
    }
}
</script>
